<template>
  <div
    :id="id"
    class="chart"
  />
</template>

<script>
import * as echarts from 'echarts';
import "echarts-gl";
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    id: {
      type: String,
      default: 'id'
    },
    title: {
      type: String,
      default: ''
    },
    showLegend: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      chart: null,
      labelMap: [
        { name1: '0 - 1', name2: '0 - 0.1', name3: '49.3-54.1' },
        { name1: '1 - 80', name2: '0.1 - 5.8', name3: '54.2-58.9' },
        { name1: '80 - 85', name2: '5.8 - 6.1', name3: '59.0-63.7' },
        { name1: '85 - 88', name2: '6.1 - 6.4', name3: '63.8-67.3' },
        { name1: '88 - 92', name2: '6.4 - 6.8', name3: '67.4-69.7' },
        { name1: '92及以上', name2: '6.8及以上', name3: '69.8-73.3' }
      ],
      electricLabelMap: [
        { name1: '0 - 0.1', name2: '0 - 0.1' },
        { name1: '0.1 - 10', name2: '0.1 - 60' },
        { name1: '10 - 13', name2: '60 - 65' },
        { name1: '13 - 16', name2: '65 - 70' },
        { name1: '16 - 19', name2: '70 - 75' },
        { name1: '19 - 24', name2: '75 - 86' }
      ],
      electricLabelMap2: [
        { name1: '0 - 0.1', name2: '0 - 0.1' },
        { name1: '0.1 - 1.5', name2: '0.1 - 3' },
        { name1: '1.5 - 2', name2: '3 - 5' },
        { name1: '2 - 2.5', name2: '5 - 7' },
        { name1: '2.5 - 3', name2: '7 - 9' },
        { name1: '3及以上', name2: '9以上' }
      ],
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    handleDataList(dataList, type, machineNum) {
      let data = []
      var colorList = {
        level1: '#accfff',
        level2: '#1871fe',
        level3: '#18c5fe',
        level4: '#44dd9e',
        level5: '#fff22f',
        level6: '#f87c20'
      };
      if (type <= 3 || type == 6) {
        let n = 0
        for (let key in dataList) {
          let name = type == 2 ? this.labelMap[n].name2 : type == 6 ? this.labelMap[n].name3 : this.labelMap[n].name1
          if (key === 'num') continue
          data.push({
            value: dataList[key]?dataList[key] : 0,
            name,
            label: {
              show: dataList[key] > 0
            },
            itemStyle: {
              opacity: 1,
              color: dataList[key]? colorList[key] : colorList['level1']
            }
          })
          n++
        }
      }
      if (type == 4) {
        let n = 0
        for (let key in dataList) {
          let name = machineNum == 3 ? this.electricLabelMap[n].name2 : this.electricLabelMap[n].name1
          if (key === 'num') continue
          data.push({
            value: dataList[key]?dataList[key] : 0,
            name,
            label: {
              show: dataList[key] > 0
            },
            itemStyle: {
              opacity: 1,
              color: dataList[key]? colorList[key] : colorList['level1']
            }
          })
          n++
        }
      }
      if (type == 5) {
        let n = 0
        for (let key in dataList) {
          let name = machineNum == 3 ? this.electricLabelMap2[n].name2 : this.electricLabelMap2[n].name1
          if (key === 'num') continue
          data.push({
            value: dataList[key]?dataList[key] : 0,
            name,
            label: {
              show: dataList[key] > 0
            },
            itemStyle: {
              opacity: 1,
              color: dataList[key]? colorList[key] : colorList['level1']
            }
          })
          n++
        }
      }
      return data
    },
    // initChart(dataList, type, machineNum) {
    //   if (!this.chart) this.chart = echarts.init(document.getElementById(this.id))
    //   let data1 = this.handleDataList(dataList, type, machineNum)
    //   this.chart.setOption({
    //     tooltip: {
    //       trigger: 'item',
    //       formatter: '{b}: ({d}%)'
    //     },
    //     series: [
    //       {
    //         type: 'pie',
    //         radius: ['40%', '70%'],
    //         z: 10,
    //         // roseType: 'radius',
    //         label: {
    //           formatter: '{per|{d}%}  ',
    //           position: 'inner',
    //           left: '20%',
    //           rich: {
    //             per: {
    //               color: '#fff',
    //             }
    //           }
    //         },
    //         labelLine: {
    //           show: false
    //         },
    //         itemStyle: {
    //           borderRadius: 5,
    //           borderWidth: 2,
    //           shadowBlur: 10,
    //           shadowColor: 'rgba(0, 0, 0, 5)',
    //           shadowOffsetX: 10,
    //           shadowOffsetY: 10,

    //           color: function (params) {
    //             // 预定义一个颜色数组
    //             var colorList = [
    //               '#fec200', '#17c5fd', '#1770fd', '#67C23A', '#F56C6C',
    //               '#FAD860'
    //             ];
    //             // 返回每个饼图扇区的颜色
    //             return colorList[params.dataIndex % colorList.length];
    //           },

    //         },
    //         data: data1
    //       }
    //     ]
    //   })
    // }
    initChart(dataList, type, machineNum) {
      const chartDom = document.getElementById(this.id)
      this.rightChart2 = echarts.init(chartDom)
      function getParametricEquation(
        startRatio,
        endRatio,
        isSelected,
        isHovered,
        k,
        height
      ) {
        // 计算
        const midRatio = (startRatio + endRatio) / 2

        const startRadian = startRatio * Math.PI * 2
        const endRadian = endRatio * Math.PI * 2
        const midRadian = midRatio * Math.PI * 2

        // 如果只有一个扇形，则不实现选中效果。
        if (startRatio === 0 && endRatio === 1) {
          isSelected = false
        }

        // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
        k = typeof k !== 'undefined' ? k : 1 / 3

        // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
        const offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0
        const offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0

        // 计算高亮效果的放大比例（未高亮，则比例为 1）
        const hoverRate = isHovered ? 1.05 : 1

        // 返回曲面参数方程
        return {
          u: {
            min: -Math.PI,
            max: Math.PI * 3,
            step: Math.PI / 32
          },

          v: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20
          },

          x: function(u, v) {
            if (u < startRadian) {
              return (
                offsetX +
                Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            if (u > endRadian) {
              return (
                offsetX +
                Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate
          },

          y: function(u, v) {
            if (u < startRadian) {
              return (
                offsetY +
                Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            if (u > endRadian) {
              return (
                offsetY +
                Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate
          },

          z: function(u, v) {
            if (u < -Math.PI * 0.5) {
              return Math.sin(u)
            }
            if (u > Math.PI * 2.5) {
              return Math.sin(u)
            }
            return Math.sin(v) > 0 ? 1 * height : -1
          }
        }
      }
      // 生成模拟 3D 饼图的配置项
      function getPie3D(pieData, internalDiameterRatio) {
        const series = []
        let sumValue = 0
        let startValue = 0
        let endValue = 0
        const legendData = []
        const k =
          typeof internalDiameterRatio !== 'undefined'
            ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio)
            : 1 / 3

        // 为每一个饼图数据，生成一个 series-surface 配置
        for (let i = 0; i < pieData.length; i++) {
          sumValue += pieData[i].value

          const seriesItem = {
            name:
              typeof pieData[i].name === 'undefined'
                ? `series${i}`
                : pieData[i].name,
            type: 'surface',
            parametric: true,
            wireframe: {
              show: false
            },
            pieData: pieData[i],
            pieStatus: {
              selected: false,
              hovered: false,
              k: k
            }
          }

          if (typeof pieData[i].itemStyle !== 'undefined') {
            const itemStyle = {}

            typeof pieData[i].itemStyle.color !== 'undefined'
              ? (itemStyle.color = pieData[i].itemStyle.color)
              : null
            typeof pieData[i].itemStyle.opacity !== 'undefined'
              ? (itemStyle.opacity = pieData[i].itemStyle.opacity)
              : null

            seriesItem.itemStyle = itemStyle
          }
          series.push(seriesItem)
        }

        // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
        // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
        for (let i = 0; i < series.length; i++) {
          endValue = startValue + series[i].pieData.value
          series[i].pieData.startRatio = startValue / sumValue
          series[i].pieData.endRatio = endValue / sumValue
          series[i].parametricEquation = getParametricEquation(
            series[i].pieData.startRatio,
            series[i].pieData.endRatio,
            false,
            false,
            k,
            2000
          )

          startValue = endValue

          legendData.push(series[i].name)
        }
        return series
      }
      // 传入数据生成 option
      // const optionsData = [
      //   {
      //     name: '国际货代',
      //     value: 13.87,
      //     itemStyle: {
      //       opacity: 0.5,
      //       color: '#7bc35a'
      //     }
      //   },
      //   {
      //     name: '租赁业务',
      //     value: 0.6,
      //     itemStyle: {
      //       opacity: 0.5,
      //       color: '#2f97df'
      //     }
      //   },
      //   {
      //     name: '仓储装卸',
      //     value: 9.53,
      //     itemStyle: {
      //       opacity: 0.5,
      //       color: '#4268d6'
      //     }
      //   },
      //   {
      //     name: '干线运输',
      //     value: 72.17,
      //     itemStyle: {
      //       opacity: 0.5,
      //       color: '#d35e5f'
      //     }
      //   },
      //   {
      //     name: '配送业务',
      //     value: 3.67,
      //     itemStyle: {
      //       opacity: 0.5,
      //       color: '#c2c763'
      //     }
      //   },
      //   {
      //     name: '其他业务',
      //     value: 0.17,
      //     itemStyle: {
      //       opacity: 0.5,
      //       color: '#8fdffe'
      //     }
      //   }
      // ]
      let optionsData = this.handleDataList(dataList, type, machineNum)
      const series = getPie3D(optionsData.map(item => {
        if (item.value < 5) {
          // item.value = 5
        }
        return item
      }), 0, 240, 28, 26, 0.5)
      series.push({
        name: 'pie2d',
        type: 'pie',
        label: {
          show: false,
          opacity: 1,
          position: 'outside',
          fontSize: 12,
          lineHeight: 20,
          textStyle: {
            show: false,
            fontSize: 12,
            color: '#fff'
          },
          normal: {
            show: false
          }
        },
        labelLine: {
          show: false,
          length: 30,
          length2: 30,
          normal: {
            show: false
          }
        },
        itemStyle: {
          color: function(params) {
            var colorList = [
              '#accfff', '#1871fe', '#18c5fe', '#44dd9e', '#fff22f',
              '#f87c20'
            ];
            // 返回每个饼图扇区的颜色
            return colorList[params.dataIndex % colorList.length];
          }
        },
        minAngle: 10,
        startAngle: -50, // 起始角度，支持范围[0, 360]。
        clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ['0', '25%'],
        center: ['50%', '50%'],
        data: optionsData.map(item => {
          item.itemStyle.opacity = 0
          return item
        })
      })
      // 准备待返回的配置项，把准备好的 legendData、series 传入。
      const option = {
        legend: {
          show: false
        },
        animation: true,
        tooltip: {
          formatter: (params) => {
            let valueList = option.series
            let total = 0
            for (let i = 0; i< valueList.length; i++) {
              let p = valueList[i].pieData
              if(p) {
                total +=p.value
              }
            }
            if (
              params.seriesName !== 'mouseoutSeries' &&
              params.seriesName !== 'pie2d'
            ) {
              return `${
                params.seriesName
              }<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                params.color
              };"></span>${
                option.series[params.seriesIndex].pieData.value == 0? 0 : ((option.series[params.seriesIndex].pieData.value / total)*100).toFixed(2) + '%'
              }`
            }
          },
          textStyle: {
            fontSize: 14
          }
        },
        title: {
          x: 'center',
          top: '20',
          textStyle: {
            color: '#fff',
            fontSize: 22
          }
        },
        // backgroundColor: '#0E3567',
        labelLine: {
          show: false,
          lineStyle: {
            color: '#7BC0CB'
          },
          normal: {
            show: false,
            length: 10,
            length2: 10
          }
        },
        label: {
          show: false,
          position: 'outside',
          formatter: '{b} \n{d}%',
          textStyle: {
            show: false,
            color: '#fff',
            fontSize: '12px'
          }
        },
        xAxis3D: {
          min: -1,
          max: 1
        },
        yAxis3D: {
          min: -1,
          max: 1
        },
        zAxis3D: {
          min: -1,
          max: 1
        },
        grid3D: {
          show: false,
          boxHeight: 0.01,
          // top: '30%',
          bottom: '50%',
          // environment: "rgba(255,255,255,0)",
          viewControl: {
            distance: 300,
            alpha: 35,
            beta: 60,
            autoRotate: false // 自动旋转
          }
        },
        series: series
      }
      this.rightChart2.setOption(option)
    }

  }
}
</script>

<style scoped lang="scss">
.chart {
  height: 100%;
}
</style>
